<template>
  <div>
    <div class="header mb-5">
      <h2 class="title">Register / Sign In to:</h2>
      <div>
        <RegisterMainMenu />
      </div>
    </div>
    <div class="description">
      <div class="row mb-5">
        <div class="col-md-6">
          <h2 class="text-right">Rosters</h2>
        </div>
        <div class="col-md-4">
          <p>
            Create and save individual team rosters for use in current and
            future orders.
          </p>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-md-6">
          <h2 class="text-right">Submit orders</h2>
        </div>
        <div class="col-md-4">
          <p>
            Submit Orders and wiew status of your submitted orders.
          </p>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-md-6">
          <h2 class="text-right">Orders history</h2>
        </div>
        <div class="col-md-4">
          <p class="minHeight">Review your order history.</p>
        </div>
      </div>
      <div class="row mb-3 mt-2">
        <div class="col-md-6">
          <h2 class="text-right">Reorder</h2>
        </div>
        <div class="col-md-4">
          <p>
            Reorder from previous orders.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import RegisterMainMenu from '@/components/Header/MainMenu/Register'
@Component({
  components: { RegisterMainMenu }
})
export default class NeedsLogged extends Vue {}
</script>

<style lang="scss" scoped>
.title {
  text-transform: none;
}
.minHeight {
  height: 44px;
}
</style>
